import ListExpenses from '../list-expenses/page';
import { useExpenseQueries } from '../../shared/tanstack/expenses/queries';
import { useQuery } from '@tanstack/react-query';
import useLoaderDisplay from '../../shared/hooks/loader-display';
import { useCircleQueries } from '../../shared/tanstack/circle/queries';
import Clickable from '../../components/essence/core/clickable';
import ExpenseSummary from '../expense-summary/page';
import AddNewExpense from './components/add-new-expense/page';
import { useEffect, useState } from 'react';
import accountService from '../../shared/services/account-service';

interface Props {
	id: string;
}
export default function Expenses(props: Props) {
	const { expensesQuery, expensesSummaryQuery } = useExpenseQueries();
	const { participantsQuery } = useCircleQueries();
	const [loggedInUserId, setLoggedInUserId] = useState('');

	const { data: expenses, isLoading } = useQuery(expensesQuery(props.id));
	useLoaderDisplay({ key: 'getExpenses', isLoading });
	const { data: expensesSummary } = useQuery(expensesSummaryQuery(props.id));
	const { data: participants } = useQuery(participantsQuery(props.id));

	useEffect(() => {
		const account = accountService.getAccount();
		if (account) {
			setLoggedInUserId(account.id);
		}
	}, []);

	return (
		<>
			<Clickable key="add-expenses">
				<AddNewExpense circleId={props.id} />
			</Clickable>
			<div className="mt-3" />
			{/* <EssenceAnimatedButton name="Add Expense" onClick={goToAddExpenses} /> */}
			{expensesSummary && expensesSummary.length > 0 && (
				<ExpenseSummary
					expensesSummary={expensesSummary}
					participants={participants ?? []}
					circleId={props.id}
				/>
			)}

			{expenses && <ListExpenses expenses={expenses} circleId={props.id} loggedInUserId={loggedInUserId} />}
		</>
	);
}
